<script>
import Pagination from '@/components/Pagination'
import {cancleOrderItem, auctionOrderList, payOrderList, onePricePay, checkPaymentStatus, confirmRceiptItem} from '@/api/xunyou'
import {downloadDevices} from '@/api/excel'
export default {
  // 注册组件
  components: {Pagination},
  data () {
    return {
      loading:false,
      dialogVisible:false,
      orderList: [], // 订单列表
      payLogList: [], // 支付记录列表
      exportOrder: '', // 导出订单
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      // 分页参数
      pageparm:{
        pageSize:10,
        currentPage:1,
        total:0,
      },
      // 请求数据参数
      formInline: {
        pageSize: 10,
        pageNum: 1,
        auctionType: 2,
        muid: JSON.parse(localStorage.getItem("userdata")).userId,
        status: '',
      },
      activeName: 0, // 当前选中的标签页
      downUrl: '/custom/xunyou/web/auction/export',
      payDialogVisible: false,
      payMoney: 0, // 支付金额
      unPayMoney: 0, // 未支付金额
      orderObj:{},
      payStatusFilters: [
        { text: '待支付', value: 0 },
        { text: '未支付', value: 1 },
        { text: '已支付', value: 2 }
      ],
      orderItem:  {},
    }
  },
  created() {
    const merOrderNo = this.$route.query.merOrderNo;
    if (merOrderNo) {
      this.showPaymentConfirmationDialog(merOrderNo);
    }
  },
  mounted() {
    this.getAuctionOrder_list()
  },
  methods: {
    // 银联收银台支付完成后重定向当前页面
    showPaymentConfirmationDialog(merOrderNo) {
      this.$confirm('请确认，您是否已经完成支付？', '支付确认', {
        confirmButtonText: '已支付',
        cancelButtonText: '未支付',
        type: 'info'
      }).then(() => {
        // 用户确认已支付
        this.checkPaymentStatus(merOrderNo, true);
      }).catch(() => {
        // 用户确认未支付或关闭模态框
        this.removeMerOrderNoAndRefresh();
      });
    },
    // 验证支付状态，手动触发查询支付订单状态
    checkPaymentStatus(merOrderNo, isAuto) {
      console.log('merOrderNo', merOrderNo)
      checkPaymentStatus({ merOrderNo:  merOrderNo  })
        .then(response => {
          console.log('response', response)
          if (response.code === 0) {
            this.$message.success('查询成功');
            if(isAuto) {
              this.refreshPage();
            }else {
              this.getPayLog(this.orderItem);
            }

          } else {
            this.$message.error('查询失败: ' + response.msg);
            if(isAuto) {
              this.refreshPage();
            } else {
              this.getPayLog(this.orderItem);
            }
          }
        })
        .catch(error => {
          console.error('验证支付状态失败:', error);
          if(isAuto) {
            this.refreshPage();
          }
        })
        .finally(() => {
          if(isAuto) {
            this.removeMerOrderNoAndRefresh();
          }

          }
        );
    },
    // 移除 URL 中的 merOrderNo 参数并刷新页面
    removeMerOrderNoAndRefresh() {
      const query = { ...this.$route.query };
      delete query.merOrderNo;
      this.$router.replace({ query }).then(() => {
        this.refreshPage();
      });
    },
    // 刷新当前页面
    refreshPage() {
      this.$router.go(0);
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getAuctionOrder_list()
    },
    // 当前用户可参与的拍卖列表接口
    getAuctionOrder_list(){
      this.loading =true
      auctionOrderList(this.formInline)
        .then(res => {
          if (res.code === 0) {
            this.loading = false
            this.orderList = res.rows;
            this.pageparm.currentPage = this.formInline.pageNum
            this.pageparm.pageSize = this.formInline.pageSize
            this.pageparm.total = res.total
          } else if(1 === parseInt(res.code)) {
            this.$router.push({path:'/login'})
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          console.log('getAuctionOrder_list fail', err)
          this.loading = false
          this.$message.error('查询订单失败，请稍后再试！')
        })
    },
    //   切换tab
    tabHandleClick(tab, event) {
      console.log(tab.name, 'tab切换');
      this.formInline.status = tab.name==0?'':tab.name
      this.getAuctionOrder_list();
    },
    gotoDetail(item){
      this.$router.push({path:'/auctionOrderDetail',query:{oid:item.oid}})
    },
    // 弹窗展示支付记录
    showDialog(item) {
      this.payDialogVisible = true;
      this.orderObj = item;
      this.unPayMoney = item.amount - item.paidAmount
    },
    // 弹窗展示支付记录
    hideDialog() {
      this.payDialogVisible = false;
      this.orderObj = {}
      this.unPayMoney = 0
    },
    payMoneyAgain() {
      this.payDialogVisible = true;
      if(this.payMoney <= 0) {
        this.$message.error('请输入正确金额！')
        return
      }

      // 确保 payMoney 精确到两位小数
      this.payMoney = parseFloat(this.payMoney).toFixed(2);

      this.loading = true
      console.log('继续支付金额', this.payMoney)

      // 获取当前页面的绝对路径
      const currentUrl = window.location.href + "?merOrderNo=";

      onePricePay({orderNumber: this.orderObj.orderNumber,
        uid: this.userInfo.userId,
        price: this.payMoney,
        upbcReturnUrl: currentUrl})
        .then(res => {
          if (res.code === 0) {
            this.loading = false
            this.hideDialog();
            // res.msg返回包含http，则执行重定向
            if (res.data.includes('http')) {
              // 重定向
              window.location.href = res.data;
            }
          } else if(1 === parseInt(res.code)) {
            this.$router.push({path:'/login'})
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          this.loading = false
          console.log('orderLogList fail', err)
        })
        .finally(

         )
    },
    //   状态转换
    orderStatus(status){
      switch(status) {
        case 1:
          return '等待买家付款'
          break;
        case 2:
          return '等待卖家发货'
          break;
        case 3:
          return '等待买家确认收货'
          break;
        case 4:
          return '交易成功'
          break;
        case 5:
          return '交易关闭'
          break;
          // case 11:
          //      return '买家提交退单'
          //     break;
          // case 12:
          //      return '退单审核中'
          //     break;
          // case 13:
          //      return '等待卖家收货确认'
          //     break;
          // case 14:
          //      return '等待卖家退款确认'
          //     break;
          // case 15:
          //      return '等待买家收款确认'
          //     break;
        case 16:
          return '退款完成'
          break;
          // case 17:
          //      return '已拒绝退款'
          //     break;
          // case 18:
          //      return '已取消'
          //     break;
        case 35:
          return '等待上传支付凭证'
          break;
        case 33:
          return '等待店铺审核支付凭证'
          break;
        case 34:
          return '店铺审核失败'
          break;
        default:
          return '--'
      }
    },
    getStatusType(payStatus) {
      switch (payStatus) {
        case 0:
          return 'danger'; // 你可以根据需要选择合适的类型
        case 2:
          return 'success';
        // 其他状态处理
        default:
          return 'info';
      }
    },
    // 支付记录状态
    getStatusText(status) {
      switch(status) {
        case 1:
          return '未支付'
          break;
        case 2:
          return '已支付'
          break;
        default:
          return '待支付'
      }
    },
    filterPayStatus(value, row) {
      return row.payStatus === value;
    },
    // 合计支付弹窗的支付金额
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.property === 'payAmount') {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = `${parseFloat(sums[index].toFixed(2))} 元`;
          } else {
            sums[index] = '';
          }
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    // 弹窗展示支付记录
    showPayLog(item) {
      this.dialogVisible = true;
      this.getPayLog(item);
      this.orderItem = item
    },
    closeDialog() {
      this.dialogVisible = false;
      this.orderItem = {}
    },
    // 获取支付记录
    getPayLog(item){
      payOrderList({orderNumber: item.orderNumber})
        .then(res => {
          if (res.code === 0) {
            this.loading = false
            this.payLogList = res.data;
          } else {
            console.error('orderLogList fail', res.msg)
          }
        })
        .catch(err => {
          console.log('orderLogList fail', err)
        })
    },
    //   导出订单
    down(id){
      const params  = {oid:id}
      downloadDevices('GET',this.downUrl+"/"+id,params).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/xlsx' }))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', 'saleOrder.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link) // 下载完成移除元素
        window.URL.revokeObjectURL(url) // 释放掉blob对象
      })
    },
    // 确认收货
    confirmRceipt(item){
      confirmRceiptItem({oid:item.oid,orderNumber:item.orderNumber}).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '确认收货成功!'
          });
          setTimeout(() => {
            this.refreshPage();
          }, 1000); // 延迟1秒执行
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
        .catch(err => {
          this.editFormVisible = false
          this.loading = false
          this.$message.error('确认收货失败，请稍后再试！')
        })
    },

    //   取消订单
    cancleOrder(orderId) {
      this.$confirm('确定取消订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        cancleOrderItem({oid:orderId}).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '取消成功!'
            });
            setTimeout(() => {
              this.refreshPage();
            }, 1000);
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
          .catch(err => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('取消失败，请稍后再试！')
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
  }
}
</script>

<template>
  <div class="right_a_side_content">
    <h3 class="headerTitle">拍卖订单</h3>
    <el-tabs type="border-card" v-loading='loading' v-model="activeName"  @tab-click="tabHandleClick">
      <el-tab-pane name=0>
        <span slot="label">全部订单</span>
        <div class="tab_pane_content">
          <div  v-for="(item,index) in orderList" :key="index" :class="item.status===1?'orderbox_info redBorder':'orderbox_info'">
            <div class="orderbox_info_header">
              <div style="width:70%">
                <p>{{item.title}}</p>
                <span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
                <span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider direction="vertical"></el-divider>
                <span>订单状态： <i style="color: #78b942;">{{orderStatus(item.status)}}</i></span><el-divider direction="vertical"></el-divider>
                <br><span class="font-size" v-if="item.orderRemark">订单备注： <i>{{item.orderRemark}}</i></span>
              </div>
              <div>
                <span class="order_money">总金额：<i >{{ (item.amount || 0).toFixed(2) }}</i> 元</span>
                <div><span class="order_money">已支付：<i >{{ (item.paidAmount || 0).toFixed(2) }}</i> 元</span></div>
                <div><span class="unPaid_money">未支付：<i >{{ (item.amount - item.paidAmount|| 0).toFixed(2) }}</i> 元</span></div>
              </div>

            </div>
            <el-row class="order_goods_whole">
              <el-col :span="20" @click.native="gotoDetail(item)">
                <el-row class="order_goods" v-for="(goodsItem,index) in item.bxyOrderCommodityList" :key="index">
                  <el-col :span="15" class="order_Info_item">
                    <p>[{{index + 1}}] 商品名称：{{goodsItem.commodityName}}<el-divider direction="vertical"></el-divider>
                      规格：<span style="color:#78b942">{{goodsItem.bxysName!=null ? goodsItem.bxysName:'默认规格'}}</span>
                    </p>
                    <span style="padding-right: 4px">{{goodsItem.buyprice}}</span><span>x{{goodsItem.num || 1 }}</span>
                    <span> = {{ goodsItem.buyprice * goodsItem.num || 1 }}</span>
                  </el-col>
                </el-row>
                <el-col>
                  <el-button type="text" v-if="+item.num > 3" @click="gotoDetail(item)">查看更多订单商品</el-button>
                </el-col>
              </el-col>
              <el-col :span="4">
                <el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
                <el-button v-if="item.status === 1" class="buttonStyle dangerBg" type="danger" @click="showDialog(item)">立即支付</el-button>
<!--                <el-button v-if="item.status === 2 && item.deliveryStatus === 2"  class="buttonStyle" type="danger" @click="gotoDetail(item)">申请退款</el-button>-->
                <el-button class="buttonStyle" @click="down(item.oid)">导出商品</el-button>
                <el-button class="buttonStyle" @click="showPayLog(item)">支付记录</el-button>
                <el-button v-if="item.status==3?true:false" class="buttonStyle" size="mini" @click="confirmRceipt(item)">确认收货</el-button>
                <el-button v-if="item.status === 1 && item.paidAmount <= 0" class="buttonStyle" @click="cancleOrder(item.oid)">取消订单</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="noData" v-if="orderList.length==0?true:false">
          您还没有相关订单。
        </div>
      </el-tab-pane>
      <el-tab-pane name="1" label="待支付">
        <span slot="label">待支付</span>
        <div class="tab_pane_content">
          <div  v-for="(item,index) in orderList" :key="index" :class="item.status===1?'orderbox_info redBorder':'orderbox_info'">
            <div class="orderbox_info_header">
              <div style="width:80%">
                <p>{{item.title}}</p>
                <span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
                <span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider direction="vertical"></el-divider>
                <span>订单状态： <i style="color: #78b942;">{{orderStatus(item.status)}}</i></span><el-divider direction="vertical"></el-divider>
                <br><span class="font-size" v-if="item.orderRemark">订单备注： <i>{{item.orderRemark}}</i></span>

              </div>
              <div>
                <span class="order_money">总金额：<i >{{ (item.amount || 0).toFixed(2) }}</i> 元</span>
                <div><span class="order_money">已支付：<i >{{ (item.paidAmount || 0).toFixed(2) }}</i> 元</span></div>
                <div><span class="unPaid_money">未支付：<i >{{ (item.amount - item.paidAmount|| 0).toFixed(2) }}</i> 元</span></div>
              </div>

            </div>
            <el-row class="order_goods_whole">
              <el-col :span="20" @click.native="gotoDetail(item)">
                <el-row class="order_goods" v-for="(goodsItem,index) in item.bxyOrderCommodityList" :key="index">
                  <el-col :span="15" class="order_Info_item">
                    <p>[{{index + 1}}] 商品名称：{{goodsItem.commodityName}}<el-divider direction="vertical"></el-divider>
                      规格：<span style="color:#78b942">{{goodsItem.bxysName!=null ? goodsItem.bxysName:'默认规格'}}</span>
                    </p>
                    <span style="padding-right: 4px">{{goodsItem.buyprice}}</span><span>x{{goodsItem.num || 0 }}</span>
                    <span> = {{ goodsItem.buyprice * goodsItem.num || 0 }}</span>
                  </el-col>
                </el-row>
                <el-col>
                  <el-button type="text" v-if="+item.num > 3" @click="gotoDetail(item)">查看更多订单商品</el-button>
                </el-col>
              </el-col>
              <el-col :span="4">
                <el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
                <el-button v-if="item.status === 1" class="buttonStyle dangerBg" type="danger" @click="gotoDetail(item)">立即支付</el-button>
<!--                <el-button v-if="item.status === 2 && item.deliveryStatus === 2"  class="buttonStyle" type="danger" @click="gotoDetail(item)">申请退款</el-button>-->
                <el-button class="buttonStyle" @click="down(item.oid)">导出商品</el-button>
                <el-button class="buttonStyle" @click="showPayLog(item)">支付记录</el-button>
                <el-button v-if="item.status === 1 && item.paidAmount <= 0" class="buttonStyle" @click="cancleOrder(item.oid)">取消订单</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="noData" v-if="orderList.length==0?true:false">
          您还没有相关订单。
        </div>
      </el-tab-pane>
      <el-tab-pane name=2 label="待发货">
        <span slot="label">待发货</span>
        <div class="tab_pane_content">
          <div  v-for="(item,index) in orderList" :key="index" :class="item.status===1?'orderbox_info redBorder':'orderbox_info'">
            <div class="orderbox_info_header">
              <div style="width:80%">
                <p>{{item.title}}</p>
                <span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
                <span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider direction="vertical"></el-divider>
                <span>订单状态： <i style="color: #78b942;">{{orderStatus(item.status)}}</i></span><el-divider direction="vertical"></el-divider>
                <br><span class="font-size" v-if="item.orderRemark">订单备注： <i>{{item.orderRemark}}</i></span>
              </div>
              <div>
                <span class="order_money">总金额：<i >{{ (item.amount || 0).toFixed(2) }}</i> 元</span>
                <div><span class="order_money">已支付：<i >{{ (item.paidAmount || 0).toFixed(2) }}</i> 元</span></div>
                <div><span class="unPaid_money">未支付：<i >{{ (item.amount - item.paidAmount|| 0).toFixed(2) }}</i> 元</span></div>
              </div>

            </div>
            <el-row class="order_goods_whole">
              <el-col :span="20" @click.native="gotoDetail(item)">
                <el-row class="order_goods" v-for="(goodsItem,index) in item.bxyOrderCommodityList" :key="index">
                  <el-col :span="15" class="order_Info_item">
                    <p>[{{index + 1}}] 商品名称：{{goodsItem.commodityName}}<el-divider direction="vertical"></el-divider>
                      规格：<span style="color:#78b942">{{goodsItem.bxysName!=null ? goodsItem.bxysName:'默认规格'}}</span>
                    </p>
                    <span style="padding-right: 4px">{{goodsItem.buyprice}}</span><span>x{{goodsItem.num || 0 }}</span>
                    <span> = {{ goodsItem.buyprice * goodsItem.num || 0 }}</span>
                  </el-col>
                </el-row>
                <el-col>
                  <el-button type="text" v-if="+item.num > 3" @click="gotoDetail(item)">查看更多订单商品</el-button>
                </el-col>
              </el-col>
              <el-col :span="4">
                <el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
<!--                <el-button v-if="item.status === 2 && item.deliveryStatus === 2"  class="buttonStyle" type="danger" @click="gotoDetail(item)">申请退款</el-button>-->
                <el-button class="buttonStyle" @click="down(item.oid)">导出商品</el-button>
                <el-button class="buttonStyle" @click="showPayLog(item)">支付记录</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="noData" v-if="orderList.length==0?true:false">
          您还没有相关订单。
        </div>
      </el-tab-pane>
      <el-tab-pane name=3 label="待收货">
        <span slot="label">待收货</span>
        <div class="tab_pane_content">
          <div  v-for="(item,index) in orderList" :key="index" :class="item.status===1?'orderbox_info redBorder':'orderbox_info'">
            <div class="orderbox_info_header">
              <div style="width:80%">
                <p>{{item.title}}</p>
                <span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
                <span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider direction="vertical"></el-divider>
                <span>订单状态： <i style="color: #78b942;">{{orderStatus(item.status)}}</i></span><el-divider direction="vertical"></el-divider>
                <br><span class="font-size" v-if="item.orderRemark">订单备注： <i>{{item.orderRemark}}</i></span>
              </div>
              <div>
                <span class="order_money">总金额：<i >{{ (item.amount || 0).toFixed(2) }}</i> 元</span>
                <div><span class="order_money">已支付：<i >{{ (item.paidAmount || 0).toFixed(2) }}</i> 元</span></div>
                <div><span class="unPaid_money">未支付：<i >{{ (item.amount - item.paidAmount|| 0).toFixed(2) }}</i> 元</span></div>
              </div>

            </div>
            <el-row class="order_goods_whole">
              <el-col :span="20" @click.native="gotoDetail(item)">
                <el-row class="order_goods" v-for="(goodsItem,index) in item.bxyOrderCommodityList" :key="index">
                  <el-col :span="15" class="order_Info_item">
                    <p>[{{index + 1}}] 商品名称：{{goodsItem.commodityName}}<el-divider direction="vertical"></el-divider>
                      规格：<span style="color:#78b942">{{goodsItem.bxysName!=null ? goodsItem.bxysName:'默认规格'}}</span>
                    </p>
                    <span style="padding-right: 4px">{{goodsItem.buyprice}}</span><span>x{{goodsItem.num || 0 }}</span>
                    <span> = {{ goodsItem.buyprice * goodsItem.num || 0 }}</span>
                  </el-col>
                </el-row>
                <el-col>
                  <el-button type="text" v-if="+item.num > 3" @click="gotoDetail(item)">查看更多订单商品</el-button>
                </el-col>
              </el-col>
              <el-col :span="4">
                <el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
<!--                <el-button v-if="item.status === 2 && item.deliveryStatus === 2"  class="buttonStyle" type="danger" @click="gotoDetail(item)">申请退款</el-button>-->
                <el-button class="buttonStyle" @click="down(item.oid)">导出商品</el-button>
                <el-button class="buttonStyle" @click="showPayLog(item)">支付记录</el-button>
                <el-button v-if="item.status==3?true:false" class="buttonStyle dangerBg" type="danger" size="mini" @click="confirmRceipt(item)">确认收货</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="noData" v-if="orderList.length==0?true:false">
          您还没有相关订单。
        </div>
      </el-tab-pane>
      <el-tab-pane name=4 label="已完成">
        <span slot="label">已完成</span>
        <div class="tab_pane_content">
          <div  v-for="(item,index) in orderList" :key="index" :class="item.status===1?'orderbox_info redBorder':'orderbox_info'">
            <div class="orderbox_info_header">
              <div style="width:80%">
                <p>{{item.title}}</p>
                <span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
                <span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider direction="vertical"></el-divider>
                <span>订单状态： <i style="color: #78b942;">{{orderStatus(item.status)}}</i></span><el-divider direction="vertical"></el-divider>
                <br><span class="font-size" v-if="item.orderRemark">订单备注： <i>{{item.orderRemark}}</i></span>
              </div>
              <div>
                <span class="order_money">总金额：<i >{{ (item.amount || 0).toFixed(2) }}</i> 元</span>
                <div><span class="order_money">已支付：<i >{{ (item.paidAmount || 0).toFixed(2) }}</i> 元</span></div>
                <div><span class="unPaid_money">未支付：<i >{{ (item.amount - item.paidAmount|| 0).toFixed(2) }}</i> 元</span></div>
              </div>

            </div>
            <el-row class="order_goods_whole">
              <el-col :span="20" @click.native="gotoDetail(item)">
                <el-row class="order_goods" v-for="(goodsItem,index) in item.bxyOrderCommodityList" :key="index">
                  <el-col :span="15" class="order_Info_item">
                    <p>[{{index + 1}}] 商品名称：{{goodsItem.commodityName}}<el-divider direction="vertical"></el-divider>
                      规格：<span style="color:#78b942">{{goodsItem.bxysName!=null ? goodsItem.bxysName:'默认规格'}}</span>
                    </p>
                    <span style="padding-right: 4px">{{goodsItem.buyprice}}</span><span>x{{goodsItem.num || 0 }}</span>
                    <span> = {{ goodsItem.buyprice * goodsItem.num || 0 }}</span>
                  </el-col>
                </el-row>
                <el-col>
                  <el-button type="text" v-if="+item.num > 3" @click="gotoDetail(item)">查看更多订单商品</el-button>
                </el-col>
              </el-col>
              <el-col :span="4">
                <el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
<!--                <el-button v-if="item.status === 2 && item.deliveryStatus === 2"  class="buttonStyle" type="danger" @click="gotoDetail(item)">申请退款</el-button>-->
                <el-button class="buttonStyle" @click="down(item.oid)">导出商品</el-button>
                <el-button class="buttonStyle" @click="showPayLog(item)">支付记录</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="noData" v-if="orderList.length==0?true:false">
          您还没有相关订单。
        </div>
      </el-tab-pane>
      <el-tab-pane name=5 label="已关闭">
        <span slot="label">已关闭</span>
        <div class="tab_pane_content">
          <div  v-for="(item,index) in orderList" :key="index" :class="item.status===1?'orderbox_info redBorder':'orderbox_info'">
            <div class="orderbox_info_header">
              <div style="width:80%">
                <p>{{item.title}}</p>
                <span>{{item.createTime}}</span> <el-divider direction="vertical"></el-divider>
                <span>订单号： <i>{{item.orderNumber}}</i></span> <el-divider direction="vertical"></el-divider>
                <span>订单状态： <i style="color: #78b942;">{{orderStatus(item.status)}}</i></span><el-divider direction="vertical"></el-divider>
                <br><span class="font-size" v-if="item.orderRemark">订单备注： <i>{{item.orderRemark}}</i></span>
              </div>
              <div>
                <span class="order_money">总金额：<i >{{ (item.amount || 0).toFixed(2) }}</i> 元</span>
                <div><span class="order_money">已支付：<i >{{ (item.paidAmount || 0).toFixed(2) }}</i> 元</span></div>
                <div><span class="unPaid_money">未支付：<i >{{ (item.amount - item.paidAmount|| 0).toFixed(2) }}</i> 元</span></div>
              </div>

            </div>
            <el-row class="order_goods_whole">
              <el-col :span="20" @click.native="gotoDetail(item)">
                <el-row class="order_goods" v-for="(goodsItem,index) in item.bxyOrderCommodityList" :key="index">
                  <el-col :span="15" class="order_Info_item">
                    <p>[{{index + 1}}] 商品名称：{{goodsItem.commodityName}}<el-divider direction="vertical"></el-divider>
                      规格：<span style="color:#78b942">{{goodsItem.bxysName!=null ? goodsItem.bxysName:'默认规格'}}</span>
                    </p>
                    <span style="padding-right: 4px">{{goodsItem.buyprice}}</span><span>x{{goodsItem.num || 0 }}</span>
                    <span> = {{ goodsItem.buyprice * goodsItem.num || 0 }}</span>
                  </el-col>
                </el-row>
                <el-col>
                  <el-button type="text" v-if="+item.num > 3" @click="gotoDetail(item)">查看更多订单商品</el-button>
                </el-col>
              </el-col>
              <el-col :span="4">
                <el-button class="buttonStyle" @click="gotoDetail(item)">订单详情</el-button>
                <!--                <el-button v-if="item.status === 2 && item.deliveryStatus === 2"  class="buttonStyle" type="danger" @click="gotoDetail(item)">申请退款</el-button>-->
                <el-button class="buttonStyle" @click="down(item.oid)">导出商品</el-button>
                <el-button class="buttonStyle" @click="showPayLog(item)">支付记录</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="noData" v-if="orderList.length==0?true:false">
          您还没有相关订单。
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 分页组件 -->
    <el-col :span="24" class="pagination">
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </el-col>

    <!--  支付记录弹窗  -->
    <el-dialog title="支付记录" :visible.sync="dialogVisible" width="1338px">
      <el-table :data="payLogList" style="width: 100%;" border  show-summary :summary-method="getSummaries">
        <el-table-column property="merOrderNo" label="支付单号" width="290" header-align="center" align="center"></el-table-column>
        <el-table-column property="amount" label="金额" width="170" header-align="center" align="center"></el-table-column>
        <el-table-column property="payAmount" label="支付金额" width="170" header-align="center" align="center"></el-table-column>
        <el-table-column property="payStatus" label="支付状态" header-align="center" align="center"
                         :filters="payStatusFilters"
                         :filter-method="filterPayStatus">
          <template slot-scope="scope">
            <el-tag
              :type="getStatusType(scope.row.payStatus)"
              disable-transitions> {{ getStatusText(scope.row.payStatus) }}</el-tag>

          </template>
        </el-table-column>
        <el-table-column property="payTime" label="支付日期" width="170" header-align="center" align="center"></el-table-column>
        <el-table-column label="支付人" width="150" header-align="center" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.currentMerName">{{ scope.row.currentMerName }}</span>
            <span v-else-if="scope.row.nickname">{{ scope.row.nickname }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column property="createTime" label="创建日期" width="166" header-align="center" align="center"></el-table-column>
        <el-table-column property="payStatus"  label="操作" width="90" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.payStatus === 0"  size="small" type="success" @click="checkPaymentStatus(scope.row.merOrderNo, false)">已支付</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDialog()" class="buttonBgd">确 定</el-button>
      </span>
    </el-dialog>

    <!--     再次支付弹窗     -->
    <el-dialog
      title="确认支付"
      :visible.sync="payDialogVisible"
      width="30%"
      center>
      <div style="font-size: 14px; text-align: left; color: #78b942; margin-top: 10px;">
        <div style="background-color: #f0f9eb; border: 1px solid #e1f3d8; border-radius: 8px; padding: 10px;">
          <span style="color: red;"><strong>温馨提示：</strong></span>
          <br>
          1、订单支付状态同步可能会存在延时，如果支付成功，请稍后查看订单的支付状态
          <br>
          2、订单待支付金额如果小于银行卡单次支付限额的，可以直接填写订单待支付金额。
          <br>
          3、订单待支付金额如果大于银行卡单次支付限额的，请填写银行单次支付限额金额，分多次进行支付。
        </div>
      </div>
      <div style="font-size: 16px; text-align: left; padding: 0 20px; margin-top: 20px;">
        <div>
          <span><strong>待支付金额：</strong><i style="color: #d01717">{{ (unPayMoney || 0).toFixed(2) }}</i> 元</span>
        </div>
        <div style="margin-top: 18px; display: flex; align-items: center;">
          <span><strong>本次支付金额：</strong></span>
          <input type="number" v-model="payMoney" autocomplete="off" style="margin-left: 10px;">
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
              <el-button @click="payDialogVisible = false" style="margin-right: 40px">取 消</el-button>
              <el-button type="primary" class="buttonBgd" @click="payMoneyAgain()">确 定</el-button>
            </span>
    </el-dialog>

  </div>
</template>

<style scoped lang="less">
  .noData{
    text-align: center;
    height: 200px;
    line-height: 200px;
  }
  .right_a_side_content {

    .headerTitle {
      font-size: 20px;
      height: 40px;
      line-height: 40px;
      color: #666;
    }
    i.pointNum {
      font-size: 42px;
      font-weight: 600;
    }
    /deep/.el-tabs--border-card{
      border: 0px;
      box-shadow: unset;
      .el-tabs__header{
        border-bottom: 0px;
        background: white;
        /deep/ .el-tabs__item.is-active {
          color:  #78b942;
          background-color: transparent;
          border-right-color: transparent;
          border-left-color: transparent;
        }
      }
    }
    .tab_pane_content{
      .noData{
        text-align: center;
        height: 200px;
        line-height: 200px;
      }
      .redBorder {
        border: 1px solid #78b942 !important;
      }
      .orderbox_info {
        // padding: 20px;
        // box-sizing: border-box;
        margin-bottom: 10px;
        border: 1px solid#ccc;
        .orderbox_info_header {
          padding: 20px;
          box-sizing: border-box;
          border-bottom: 1px solid #ccc;
          display: flex;
          justify-content: space-between;
          p{
            font-size: 16px;
            color: #78b942;
            margin-bottom: 5px;
          }
          .order_money i{
            font-size: 20px;
            color: #78b942;
          }
          .unPaid_money i{
            font-size: 20px;
            color: #e13c41;
          }
        }
        .order_goods_whole {
          padding: 20px;
          box-sizing: border-box;
          .order_goods {
            margin-bottom: 20px;
            .order_Info_item {
              margin-left: 20px;
            }
          }
          button.el-button.buttonStyle {
            padding: 6px 30px;
            font-size: 12px;
            margin-bottom: 6px;
            margin-left: 0;
          }
          .buttonStyleMerge {
            padding: 6px 10px;
            font-size: 12px;
            margin-bottom: 6px;
            margin-left: 0;
          }
          .dangerBg.buttonStyle{
            background-color:  #78b942;
            border-color:  #78b942;
          }
          .el-button--danger.is-plain{
            background: white;
          }
          .el-button--danger:focus, .el-button--danger:hover{
            color: white;
            background: #78b942;
          }
        }
      }
    }


    .pagination{
      text-align: right;
      /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #78b942;
        color: #FFF;
        width: 20px;
      }
      /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li {
        width: 20px;
      }
      /deep/input[disabled], input[disabled="disabled"], input[readonly], input[readonly="readonly"] {
        background-color: transparent;
      }
    }

    /deep/.buttonBgd {
      background-color: #78b942;
      border-color: #78b942;
      font-size: 14px;
      margin: 20px 0 20px 60px;
    }

    .dialog-footer {
      margin-top: -20px;
      display: block;
    }
  }

  .header-bg {
    background-color: #f0f9eb; /* 你可以根据需要更改颜色 */
    color: #67c23a; /* 可选：设置文字颜色 */
  }
</style>



// WEBPACK FOOTER //
// src/views/auction/auctionOrder.vue